import z from "zod";

export const filterSchema = z.object({
  techs: z.array(z.string()).optional(),
  projectRelated: z.string().optional(),
  projectType: z.string().optional(),
  liveDemoLink: z.string().optional(),
});

export type TFilterSchema = z.infer<typeof filterSchema>;
